import { render, staticRenderFns } from "./CampaignStatistics.vue?vue&type=template&id=61156a8e&scoped=true&"
import script from "./CampaignStatistics.vue?vue&type=script&lang=ts&"
export * from "./CampaignStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignStatistics.vue?vue&type=style&index=0&id=61156a8e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61156a8e",
  null
  
)

export default component.exports